import styled from 'styled-components';

export const Container = styled.div<{ $isPatientLoggedIn?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  border: none;

  > button {
    max-width: 400px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
    width: ${({ $isPatientLoggedIn }) => ($isPatientLoggedIn ? 'calc(100% - 80px)' : '100%')};
    background-color: ${({ theme }) => theme.colors.neutral.lavenderWhite};
    position: fixed;
    top: 0;
    right: 0;
    left: ${({ $isPatientLoggedIn }) => ($isPatientLoggedIn ? '80px' : '0')};
    z-index: ${({ theme }) => theme.layers.modal};
    margin-top: 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.neutral.lavender};
    border-top: none;
    border-left: none;
    border-right: none;
  }
`;

export const NavigationContainer = styled.div`
  margin-top: 85px;
  display: flex;
  justify-content: center;
  width: 100%;

  > button {
    max-width: 400px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
    width: calc(100% - 80px);

    position: fixed;
    top: 0;
    right: 0;
    z-index: ${({ theme }) => theme.layers.overlay};

    margin-top: 0;
  }
`;

export const MobileNavigationContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 24px;
  width: 100%;
`;

export const NavigationContent = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
    width: 800px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 16px 12px;
    position: relative;

    > *:nth-child(2) {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      margin: 0;
    }

    > button:first-child {
      position: relative;
      z-index: 1;
    }

    > button:last-child,
    > div:last-child {
      position: relative;
      z-index: 1;
    }
  }
`;

export const ProgressAndHeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;
